import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import UserModel from "./models/UserModel";
import UserModal from "./UserModal";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';
import { getApiBaseUrl } from "../../utils/apiConfig";
function AddUserGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [userModel, setUserModel] = useState(new UserModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);

  function closeModal() {
    setIsOpen(false);
    props.fetchUser();
  }

  const rows = props.UserData
    ? props.UserData.filter(
      (item) =>
        (item.FullName &&
          item.FullName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.UserName &&
          item.UserName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.PhoneNumber &&
          item.PhoneNumber.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    setUserModel(row);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    if (e.target.name === "EditUser") {
      const userModel = data;
      let registerDetails = {
        FullName: userModel.FullName,
        UserName: userModel.UserName,
        Email: userModel.Email,
        PhoneNumber: userModel.PhoneNumber,
        PasswordHash: userModel.Password,
        UserId: userModel.Id,
        RoleId: userModel.RoleId,
        CompanyId: userModel.CompanyId,
        ModuleId: userModel.DefaultModuleId
      };
      if (validation(registerDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/register", registerDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchUser();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if (e.target.name === "DeleteUser") {
      const element = document.getElementById("DeleteUserDetails");
      const userModel = JSON.parse(element.innerHTML);
      let registerDetails = {
        UserId: userModel.Id
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/deleteuser", registerDetails
        );
        if (response.status === 200) {
          CreateAlert("User deleted successfully!!", "Success", setAlert);
          props.fetchUser();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    } else if (e.target.name === "ResetPassword") {
      const passwordModel = data;
      try {
        let resetPasswordDetails = {
          UserId: passwordModel.Id,
          ConfirmPassword: passwordModel.ConfirmPassword,
          NewPassword: passwordModel.NewPassword
        };
        if (validateResetPassword(resetPasswordDetails)) {
          const res = await axios.post(getApiBaseUrl() + "/resetUserPassword", resetPasswordDetails);
          CreateAlert(res.data.message || "Password changed successfully!", "Success", setAlert);
          closeModal();
        }
      } catch (err) {
        CreateAlert(
          err.response?.data?.message || "Failed to change password",
          "Error",
          setAlert
        );
      }
    }
  };

  function validation(userDetails) {
    var validation = true;
    if (userDetails) {
      if (userDetails.FullName !== null) {
        if (userDetails.FullName.length === 0) {
          CreateAlert("Please enter user name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter user name!!", "Warning", setAlert);
        validation = false;
        return;
      }

      if (userDetails.Email !== null) {
        if (userDetails.Email.length === 0) {
          CreateAlert("Please enter email!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter email!!", "Warning", setAlert);
        validation = false;
        return;
      }

      if (userDetails.UserName !== null) {
        if (userDetails.UserName.length === 0) {
          CreateAlert("Please enter user name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter user name!!", "Warning", setAlert);
        validation = false;
        return;
      }

      if (userDetails.RoleId !== null) {
        if (userDetails.RoleId.length === 0) {
          CreateAlert("Please select role!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please select role!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }

  function validateResetPassword(userDetails) {
    var validation = true;
    if (userDetails) {
      if (userDetails.NewPassword && userDetails.NewPassword !== null) {
        if (userDetails.NewPassword.length === 0) {
          CreateAlert("Please enter new password!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter new password!!", "Warning", setAlert);
        validation = false;
        return;
      }

      if (userDetails.ConfirmPassword && userDetails.ConfirmPassword !== null) {
        if (userDetails.ConfirmPassword.length === 0) {
          CreateAlert("Please enter confirm password!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter confirm password!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }

  const columns = [
    {
      name: <div className="titlename"><span>Full Name </span></div>,
      selector: row => row.FullName,
      cell: (row) => (
        <span title={row.FullName}>{row.FullName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>User Name </span></div>,
      selector: row => row.UserName,
      cell: (row) => (
        <span title={row.UserName}>{row.UserName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>,
    },
    {
      name: <div className="titlename"><span>Email </span></div>,
      selector: (row) => row.Email,
      cell: (row) => (
        <span title={row.Email}>{row.Email}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Phone </span></div>,
      selector: row => row.PhoneNumber,
      cell: (row) => (
        <span title={row.PhoneNumber}>{row.PhoneNumber}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Email Confirmed </span></div>,
      cell: (row) => (
        <span
          className={
            row.EmailConfirmed === "Yes"
              ? "badge-linesuccess"
              : "badge badge-linedangered"
          }
        >
          {row.EmailConfirmed}
        </span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Phone Confirmed </span></div>,
      selector: row => row.PhoneNumberConfirmed,
      cell: (row) => (
        <span
          className={
            row.PhoneNumberConfirmed === "Yes"
              ? "badge-linesuccess"
              : "badge badge-linedangered"
          }
        >
          {row.PhoneNumberConfirmed}
        </span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Status </span></div>,
      selector: row => row.Status,
      cell: (row) => (
        <span
          className={
            row.Status === "Active"
              ? "badges status-badge"
              : "badges unstatus-badge"
          }
        >
          {row.Status}
        </span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
  ];
if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
          props.UserPermissions.AddModule === 1 ?
          <Link
            title="View User"
            className={`me-2 p-2 ${row.Id === 1 ? 'disabled-link' : ''}`}
            to=""
            onClick={() => {
              openActionType(row, "ViewUser");
            }}
          >
            <Icons.Eye data-feather="eye" className="action-eye" />
          </Link>
          :null
    }
    {
          props.UserPermissions.EditModule === 1 ?
          <Link
            title="Edit User"
            className={`me-2 p-2 ${row.Id === 1 ? 'disabled-link' : ''}`}
            to=""
            onClick={() => {
              openActionType(row, "EditUser");
            }}
          >
            <Icons.Edit data-feather="edit" className="feather-edit" />
          </Link>
          :null
    }
    {
           props.UserPermissions.DeleteModule === 1 ? 
          <Link
            title="Delete User"
            className={`confirm-text p-2 ${row.Id === 1 ? 'disabled-link' : ''}`}
            to=""
            onClick={() => {
              openActionType(row, "DeleteUser");
            }}
          >
            <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
          </Link>
          :null
    }
          <Link
            title="Reset Password"
            className={`me-2 p-2 ${row.Id === 1 ? 'disabled-link' : ''}`}
            to=""
            onClick={() => {
              openActionType(row, "ResetPassword");
            }}
          >
            <Icons.RefreshCcw data-feather="trash-2" className="feather-edit" />
          </Link>


        </div>
      ),
      center: "true",
      width: "200px"
    },);
}


  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  autoComplete="off"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            sortIcon={<SortArrow />}
            persistTableHead={true}
          />
        </div>
      </div>
      <UserModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={userModel}
        onSubmit={onSubmit}
      />
    </>
  );
}

export default AddUserGrid;
